import React, {Component} from 'react';
import {Button, Container, Alert} from "reactstrap";
import selectn from 'selectn';
import AppActions from './../actions/AppActions';
import {get} from './../lib/http';
import notifier from './../lib/notifier';
import _ from 'lodash';
import ctrlS from "../lib/ctrlS";
import FormGroup from "./forms/FormGroup";
import BoundTextInput from "./forms/BoundTextInput";
import BoundTextArea from "./forms/BoundTextArea";
import {post} from "../lib/http";
import connection from './../lib/connection';
import validateItem from "./../lib/validateItem";
import getColors from "./../lib/getColors";
import moment from 'moment';

export class SpatialAnchor extends Component {
    componentWillMount() {
        const id = selectn('match.params.id', this.props);

        this.update(id);
    }

    componentWillReceiveProps(nextProps) {
        const id = selectn('match.params.id', nextProps);
        if (id !== selectn('match.params.id', this.props)) {
            this.update(id);
        }
    }

    render() {
        const {anchor, connected, joined} = this.props;

        const onKeyDown = (event) => {
            ctrlS(event, () => {
                this.save();
            });
        };

        const {isValidMixId, isValidData, data, validateDataMessage} = validateItem(anchor);

        const colors = getColors(data);

        return (
            <Container>
                <h1>Spatial Anchor</h1>
                {anchor && anchor.id && <div>
                    <h3>{anchor.id}</h3>
                    <p>Created: {moment.utc(anchor.dateTimeCreatedUtc).local().format("DD/MM/YYYY H:mm:ss")}</p>
                </div>}

                {anchor && <div onKeyDown={onKeyDown}>
                    <FormGroup id="MixId" label="Mix id">
                        <BoundTextInput value={anchor.mixId} path="anchor.mixId" id="MixId"
                                        className="form-control input-md"/>
                        {!isValidMixId && <Alert color="danger">Invalid id</Alert>}
                        {isValidMixId &&
                        <a className="float-right" href={`https://mixiply.com/app/mix/${anchor.mixId}`} rel="noopener noreferrer" target="_blank">Open
                            in Mixiply</a>}
                    </FormGroup>

                    <FormGroup id="Data" label="Data">
                        <BoundTextArea value={anchor.data} path="anchor.data" id="Data"
                                       className="form-control"/>
                        {_.map(colors, c => <div key={c} className="mt-3 mr-3" style={{

                            height: '30px',
                            width: '30px',
                            backgroundColor: c

                        }}/>)}
                        {!isValidData && <Alert color="danger">{validateDataMessage}</Alert>}
                        <div className="clearfix"/>
                    </FormGroup>

                    <div className="form-group">
                        {connected && joined && anchor.id && <Alert color="success">Joined {joined}</Alert>}
                        <Button color="primary" className="float-right" onClick={() => this.save()}>Save</Button>
                    </div>

                </div>}

            </Container>
        );
    }

    sendUpdate(id, mixId, groupName, type) {
        if (id && groupName) {
            try {
                connection.invoke("SendDataToOthers", mixId, groupName, {
                    type,
                    id
                }).catch((err) => {
                    return console.error(err);
                });
            } catch (e) {
                console.error(e);
            }
        }
    }

    save() {
        const {anchor, joined} = this.props;

        const {isValidMixId, isValidData} = validateItem(anchor);

        if (!isValidMixId || !isValidData) {
            notifier.notify({
                level: notifier.Level.Error,
                title: 'Error',
                message: 'Fix validation errors and try again'
            });

            return;
        }

        const onSaved = (content) => {

            this.sendUpdate(anchor.id, anchor.mixId, joined, 'AnchorUpdated');

            notifier.notify({
                level: notifier.Level.Success,
                title: 'Success',
                message: 'Anchor updated'
            });

            this.update(anchor.id);
        };

        post("api/anchors/" + anchor.id, anchor, onSaved);
    }

    update(id) {
        get(
            'api/anchors/:id',
            {id},
            data => {
                AppActions.updateStates([
                    {statePath: 'anchor', data: data}
                ]);
            });
    }
}